import { Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { SnackBar } from 'src/components/SnackBar';
import CalenderView from './ViewHolidayCalender';
import Event from '../yearPlan/Event';
import './HolidayCalender.css';
import { useDispatch } from 'react-redux';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import StarIcon from '@mui/icons-material/Star';
import NavigationIcon from '@mui/icons-material/Navigation';

const HolidayCalender = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();


  return (
    <>
      <Grid container alignItems="center">
        <Grid item>
          <Typography
            sx={{ pl: 3, pt: 2 }}
            style={{
              marginLeft: '0px',
              marginTop: '7px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Holiday Calendar
          </Typography>
          <Typography variant="subtitle2"></Typography>
        </Grid>
      </Grid>
      <Grid
        maxWidth="lg"
        sx={{
          mx: window.innerWidth <= 990 ? 0 : 3,
          my: window.innerWidth <= 990 ? 0 : 3
        }}
        style={{
          display: 'flex',
          backgroundColor: 'white',
          maxHeight: window.innerHeight
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={0}
        >
          <Grid item xs={11} md={9} sx={{ my: 5 }}>
            <CalenderView />
          </Grid>
          <Grid
            item
            xs={11}
            md={9}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              mb: 5
            }}
          >
            <NavigationIcon sx={{ fontSize:'15px', color: '#00B26A', marginRight: '5px'}} />
            <div
              style={{
                marginRight: '1rem',
                color: '#00B26A',
                backgroundColor: '#E1EFE9',
                fontSize: '9px',
                padding: '7px',
                fontWeight: 'bold',
                borderRadius: '6px'
              }}
            >
              Company Holiday
            </div>
            <Grid3x3Icon sx={{ fontSize:'15px' , color: '#F1C40F', marginRight: '5px'}} />
            <div
              style={{
                marginRight: '1rem',
                color: '#F1C40F',
                backgroundColor: '#FEF9E7',
                fontSize: '9px',
                padding: '7px',
                fontWeight: 'bold',
                borderRadius: '6px'
              }}
            >
              Public Holiday
            </div>
            <StarIcon sx={{ fontSize:'15px', color: '#ED1C24', marginRight: '5px'}} />
            <div
              style={{
                marginRight: '1rem',
                color: '#ED1C24',
                backgroundColor: '#F8F2F2',
                fontSize: '9px',
                padding: '7px',
                fontWeight: 'bold',
                borderRadius: '6px'
              }}
            >
              Mercantile Holiday
            </div>
            <Brightness1Icon sx={{ fontSize:'15px', color: '#0069E4', marginRight: '5px'}} />
            <div
              style={{
                color: '#0069E4',
                backgroundColor: '#DCE7F2',
                fontSize: '9px',
                padding: '7px',
                fontWeight: 'bold',
                borderRadius: '6px'
              }}
            >
              Bank Holiday
            </div>
          </Grid>
        </Grid>
        <SnackBar />
      </Grid>
    </>
  );
};

export default HolidayCalender;
